<div class="row no-gutter layout-header" [attr.data-right]="displayRight">
  <div class="col-sm-6 d-flex">
    <h6 class="head vertical-line">Manage Users</h6>
    @if (selectedTabLabel == 'Users') {
      <h6 class="head">Users</h6>
    }
    @if (selectedTabLabel == 'Roles') {
      <h6 class="head">Roles</h6>
    }
  </div>
  @if (selectedTabLabel == 'Users' && !sharedService.inEditUser) {
    <div
      class="col-sm-6 right-header">
      @if (!displayRight) {
        <div class="rightDiv">
          @if (role != 'Vendoradmin') {
            <div class="vendor">
              <mat-select disableRipple [(ngModel)]="selectedVendor" class="selectClass"
                (ngModelChange)="vendorSelect($event)">
                <mat-option value="all" class="option">All Vendors</mat-option>
                @for (vendor of vendorCollections; track vendor) {
                  <mat-option value="{{ vendor.id }}" class="option">{{ vendor.orgName
                  }}</mat-option>
                }
              </mat-select>
            </div>
          }
          <div>
            <mat-select disableRipple [(ngModel)]="selectedUser" class="selectClass" (ngModelChange)="userSelect($event)">
              <mat-option value="all" class="option">All Users</mat-option>
              <mat-option value="active" class="option">Active</mat-option>
              <mat-option value="inactive" class="option">Inactive</mat-option>
              <mat-option value="pending" class="option">Pending</mat-option>
            </mat-select>
          </div>
          <div class="report" (click)="filterPopUp()" style="cursor: pointer">
            <p>Report</p>
            <div></div>
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="layout-panel">
  <div>
    <div class="col-12 layout-header">
      @if (
        !sharedService.inEditUser &&
        !sharedService.inAddUser &&
        !sharedService.inAddRole &&
        !sharedService.inEditRole
        ) {
        <div>
          <nav mat-tab-nav-bar class="tab-header" [tabPanel]="tabPanel" disableRipple>
            @if (showResources.users) {
              <a mat-tab-link (click)="onTabClick('Users')" routerLink="/manage-users/users"
                routerLinkActive #users="routerLinkActive" [ngClass]="users.isActive ? 'tab-active' : ''"><span
              class="tab-label">Users</span></a>
            }
            @if (
              showResources.roles &&
              (role === 'superadmin' || role === 'SuperAdminRead')
              ) {
              <a mat-tab-link (click)="onTabClick('Roles')" routerLink="/manage-users/roles" routerLinkActive #roles="routerLinkActive" [ngClass]="roles.isActive ? 'tab-active' : ''"><span
              class="tab-label">Roles</span></a>
            }
          </nav>
        </div>
      }

      @if (
        !sharedService.inEditUser &&
        !sharedService.inAddUser &&
        !sharedService.inAddRole &&
        !sharedService.inEditRole
        ) {
        <div class="searchFlag addUser">
          @if (!sharedService.deleteUsers.length) {
            <div class="search">
              <form [formGroup]="searchForm">
                <div class="searchText">
                  <img src="../../../../assets/images/search-icon.png" class="searchImg" />
                  <input class="form-control" formControlName="searchText" type="text" name="search" autocomplete="off"
                    placeholder="Search" style="font-family: Arial, FontAwesome" maxlength="60" autocomplete="off"
                    (keyup)="onSearch($event)" />
                  </div>
                </form>
              </div>
            }
            @if (user.userDetails.role != 'SuperAdminRead') {
              <div class="w-100">
                @if (selectedTabLabel == 'Roles' && !sharedService.inUser) {
                  <div>
                    <button type="button" name="createUser" class="create-action" (click)="navigatePage('addRole')"
                      routerLink="/manage-users/roles/create-role">
                      <img style="width: 15px; height: 15px" src="../../../../assets/images/Add-Role-Icon.svg"
                        class="icon-fingerprint cursor-pointer" alt="Action" />
                        <span>Add Role</span>
                      </button>
                    </div>
                  }
                  @if ((selectedTabLabel == 'Users' && !display) || sharedService.inUser) {
                    <div>
                      @if (!sharedService.deleteUsers.length) {
                        <div class="buttonsClass">
                          <button type="button" name="createUser" class="create-action addButton" (click)="navigatePage('addUser')"
                            routerLink="/manage-users/users/create-user">
                            <img style="width: 15px; height: 15px" src="../../../../assets/images/add-user-icon.svg"
                              class="icon-fingerprint cursor-pointer" alt="Add User" />
                              <span>Add User</span>
                            </button>
                            <button class="create-action add-button" mat-button [matMenuTriggerFor]="menu">
                              <img style="width: 15px; height: 15px" src="../../../../assets/images/Action-icon.svg"
                                class="icon-fingerprint cursor-pointer" alt="Action" />
                                <span>Action</span>
                              </button>
                            </div>
                          }
                          @if (sharedService.deleteUsers.length) {
                            <div class="buttonsClass">
                              <span class="deletecount">
                                {{ sharedService.deleteUsers.length }} {{sharedService.deleteUsers.length > 1 ? 'users': 'user'}}
                              selected</span>
                              <button type="button" name="deleteUser" class="delete-action create-action pull-right"
                                (click)="popupConfirm()">
                                <img src="assets/images/delete-action.svg" class="icon-fingerprint cursor-pointer" alt="Delete User" />
                                <span>Delete Users</span>
                              </button>
                            </div>
                          }
                        </div>
                      }
                      <mat-menu #menu="matMenu">
                        <input hidden type="file" #csvFileInput (change)="uploadExcel($event)" style="display: none"
                          accept=".xlsx,.xls,.csv" />
                          <button mat-menu-item (click)="downloadSample()">
                            Download Sample CSV
                          </button>
                          <button mat-menu-item (click)="csvFileInput.click()">Upload CSV</button>
                        </mat-menu>
                      </div>
                    }
                  </div>
                }
              </div>

              <div class="col-sm-12">
                <div class="tab-body">
                  <mat-tab-nav-panel #tabPanel>
                    <router-outlet></router-outlet>
                  </mat-tab-nav-panel>
                </div>
              </div>
            </div>

          </div>